type Props = {
    count?: number;
};

export default function LoadingGridItems({count = 6}: Props) {
    return (
        <>
            <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
                {Array.from({length: count}).map((_, i) => (
                    <div key={i} className="h-64 animate-pulse rounded-xl bg-gray-100"/>
                ))}
            </div>
        </>
    );
}